import { render, staticRenderFns } from "./OrmInformTotalLoss.vue?vue&type=template&id=59b4a310"
import script from "./OrmInformTotalLoss.vue?vue&type=script&lang=js"
export * from "./OrmInformTotalLoss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b4a310')) {
      api.createRecord('59b4a310', component.options)
    } else {
      api.reload('59b4a310', component.options)
    }
    module.hot.accept("./OrmInformTotalLoss.vue?vue&type=template&id=59b4a310", function () {
      api.rerender('59b4a310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OrmInformTotalLoss.vue"
export default component.exports